import React from 'react'
import { AlertCircle, X } from 'lucide-react'
import { useConfiguration } from '../contexts/ConfigurationContext'

function ErrorMessage({ message }) {
  const { dispatch } = useConfiguration()

  const handleDismiss = () => {
    dispatch({ type: 'SET_ERROR', payload: null })
  }

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex items-start space-x-3">
        <AlertCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="text-sm font-medium text-red-800">
            Error
          </h3>
          <p className="text-sm text-red-700 mt-1">
            {message}
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="text-red-400 hover:text-red-600 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}

export default ErrorMessage 